// src/components/CaseKeyPoints.js

import React from "react";
import { Card } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { PlusCircle, MinusCircle, X } from "lucide-react";

export default function CaseKeyPoints({
    keyPoints,
    handleAddCaseKeyPoint,
    handleRemoveCaseKeyPoint,
    handleCaseKeyPointChange,
    handleCaseDataPointInput,
    removeCaseDataPoint,
}) {
    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <label className="block text-sm font-medium">
                    Case Key Points
                </label>
                <Button
                    type="button"
                    onClick={handleAddCaseKeyPoint}
                    variant="outline"
                    size="sm">
                    <PlusCircle className="w-4 h-4 mr-1" />
                    Add Key Point
                </Button>
            </div>

            {keyPoints.map((kp, kpIndex) => (
                <Card key={kp.id} className="p-4">
                    <div className="space-y-2">
                        {/* Key Point Title */}
                        <div className="flex items-center justify-between">
                            <Input
                                placeholder="Key Point Title"
                                value={kp.title}
                                onChange={(e) =>
                                    handleCaseKeyPointChange(
                                        kpIndex,
                                        "title",
                                        e.target.value
                                    )
                                }
                                className="flex-1 mr-2"
                            />
                            <Button
                                type="button"
                                variant="destructive"
                                size="sm"
                                onClick={() =>
                                    handleRemoveCaseKeyPoint(kpIndex)
                                }>
                                <MinusCircle className="w-4 h-4" />
                            </Button>
                        </div>

                        {/* Data Points */}
                        <div>
                            <Input
                                placeholder="Add data point and press Enter"
                                onKeyPress={(e) =>
                                    handleCaseDataPointInput(kpIndex, e)
                                }
                            />
                            <div className="flex flex-wrap gap-1 mt-2">
                                {kp.dataPoints?.map((dp) => (
                                    <span
                                        key={dp}
                                        className="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded text-sm">
                                        {dp}
                                        <X
                                            className="w-3 h-3 cursor-pointer"
                                            onClick={() =>
                                                removeCaseDataPoint(kpIndex, dp)
                                            }
                                        />
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </Card>
            ))}
        </div>
    );
}
